import { NgModule } from '@angular/core';

import { TranslatePipe } from '@app/translate/TranslatePipe';
import { ImageCdnPipe } from '@app/pipes/image-cdn.pipe';
import { BaseImagePipe } from '@app/pipes/base-image.pipe';
import { AirportNamePipe } from '@app/pipes/airport-name.pipe';
import { SafePipe } from '@app/pipes/safe-content.pipe';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';
import { PlaceNamePipe } from '@app/pipes/place-name.pipe';
import { TimeFormatPipe } from '@app/pipes/time-format.pipe';
import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { AirlineNamePipe } from '@app/pipes/airline-name.pipe';
import { FlightDurationPipe } from '@app/pipes/flight-duration.pipe';
import { AirlineImagePipe } from '@app/pipes/airline-image.pipe';
import { AutocompleteVmPipe } from '@app/pipes/autocomplete-vm.pipe';
import { PlacePipe } from '@app/pipes/place.pipe';
import { TotalAmountPipe } from '@app/pipes/total-amount.pipe';
import { AirValidationSectorVmPipe } from '@app/pipes/air-validation-sector-vm.pipe';
import { ArrivalDaysPipe } from '@app/pipes/arrival-days.pipe';
import { BusCompanyNamePipe } from '@app/pipes/bus-company-name.pipe';
import { BusCompanyImagePipe } from '@app/pipes/bus-company-image.pipe';
import { TerminalNamePipe } from '@app/pipes/terminal-name.pipe';
import { UniqueIdPipe } from '@app/pipes/unique-id.pipe';
import { CapitalizePipe } from '@app/pipes/capitalize.pipe';
import { CountriesVmPipe } from '@app/pipes/countries.pipe';
import { CountryCodePipe } from '@app/pipes/country-code.pipe';
import { FrequentFlyerProgramsPipe } from '@app/pipes/frequent-flyer-programs.pipe';
import { PriceAbbreviationPipe } from '@app/pipes/price-abbreviation.pipe';
import { CountryNamePipe } from '@app/pipes/country-name.pipe';
import { StopNamePipe } from '@app/pipes/stop-name.pipe';
import { CapitalizeAllPipe } from '@app/pipes/capitalize-all.pipe';
import { DeeplinkPlacePipe } from '@app/pipes/deeplink-place.pipe';
import { ImageDimensionPipe } from '@app/pipes/image-dimension.pipe';
import { ImageDesktopOrMobilePipe } from '@app/pipes/image-desktop-or-mobile.pipe';
import { PackageResumePipe } from '@app/pipes/package-resume.pipe';
import { PackageResumeDesktopPipe } from '@app/pipes/package-resume-desktop.pipe';
import { UserHistoryFormatPipe } from '@app/pipes/user-history-format.pipe';
import { AirlinePoliciesLinkPipe } from '@app/pipes/airline-policies-link.pipe';
import { GuestToPassengerUIPipe } from '@app/pipes/guest-to-paseenger.pipe';
import { DateRemoveDotsPipe } from '@app/pipes/date-remove-dots.pipe';
import { ListAirlineNamesPipe } from '@app/pipes/list-airline-names.pipe';
import { ExchangeCurrencyPipe } from '@app/pipes/exchange-currency.pipe';
import { ImageHttpsPipe } from '@app/pipes/image-https.pipe';
import { PackageReservationFlightFormatPipe } from '@app/pipes/package-reservation-format.pipe';
import { FrequentFlyerNamePipe } from '@app/pipes/frequent-flyer-name.pipe';
import { SafeHtmlPipe } from '@app/pipes/safe-html.pipe';
import { TravelerDocumentsPipe } from '@app/pipes/traveler-documents.pipe';
import { HistoryListByTabPipe } from '@app/pipes/history-list-by-tab.pipe';
import { ProvincesByPipe } from '@app/pipes/provinces-by.pipe';
import { OrderByPipe } from '@app/pipes/order-by.pipe';
import { CountryCodeByAirportPipe } from '@app/pipes/country-code-by-airport';

@NgModule({
  declarations: [
    TranslatePipe,
    ImageCdnPipe,
    ImageDimensionPipe,
    BaseImagePipe,
    SafePipe,
    AirportNamePipe,
    CurrencyFormatPipe,
    PlaceNamePipe,
    PlacePipe,
    TimeFormatPipe,
    DateTransformPipe,
    AirlineNamePipe,
    FlightDurationPipe,
    AirlineImagePipe,
    AutocompleteVmPipe,
    TotalAmountPipe,
    AirValidationSectorVmPipe,
    ArrivalDaysPipe,
    BusCompanyNamePipe,
    BusCompanyImagePipe,
    TerminalNamePipe,
    UniqueIdPipe,
    CapitalizePipe,
    CountriesVmPipe,
    CountryCodePipe,
    FrequentFlyerProgramsPipe,
    CountryNamePipe,
    PriceAbbreviationPipe,
    StopNamePipe,
    CapitalizeAllPipe,
    DeeplinkPlacePipe,
    ImageDesktopOrMobilePipe,
    PackageResumePipe,
    PackageResumeDesktopPipe,
    UserHistoryFormatPipe,
    AirlinePoliciesLinkPipe,
    GuestToPassengerUIPipe,
    DateRemoveDotsPipe,
    ListAirlineNamesPipe,
    ExchangeCurrencyPipe,
    ImageHttpsPipe,
    PackageReservationFlightFormatPipe,
    FrequentFlyerNamePipe,
    SafeHtmlPipe,
    ProvincesByPipe,
    TravelerDocumentsPipe,
    HistoryListByTabPipe,
    OrderByPipe,
    CountryCodeByAirportPipe
  ],
  exports: [
    TranslatePipe,
    ImageCdnPipe,
    ImageDimensionPipe,
    BaseImagePipe,
    SafePipe,
    AirportNamePipe,
    CurrencyFormatPipe,
    PlaceNamePipe,
    PlacePipe,
    TimeFormatPipe,
    DateTransformPipe,
    AirlineNamePipe,
    FlightDurationPipe,
    AirlineImagePipe,
    AutocompleteVmPipe,
    TotalAmountPipe,
    AirValidationSectorVmPipe,
    ArrivalDaysPipe,
    BusCompanyNamePipe,
    BusCompanyImagePipe,
    TerminalNamePipe,
    UniqueIdPipe,
    CapitalizePipe,
    CapitalizeAllPipe,
    CountriesVmPipe,
    CountryCodePipe,
    FrequentFlyerProgramsPipe,
    PriceAbbreviationPipe,
    CountryNamePipe,
    StopNamePipe,
    DeeplinkPlacePipe,
    ImageDesktopOrMobilePipe,
    PackageResumePipe,
    PackageResumeDesktopPipe,
    UserHistoryFormatPipe,
    AirlinePoliciesLinkPipe,
    DateRemoveDotsPipe,
    ListAirlineNamesPipe,
    ExchangeCurrencyPipe,
    ImageHttpsPipe,
    PackageReservationFlightFormatPipe,
    FrequentFlyerNamePipe,
    SafeHtmlPipe,
    ProvincesByPipe,
    TravelerDocumentsPipe,
    HistoryListByTabPipe,
    OrderByPipe,
    CountryCodeByAirportPipe
  ],
  providers: [
    TranslatePipe,
    ImageCdnPipe,
    BaseImagePipe,
    SafePipe,
    AirportNamePipe,
    CurrencyFormatPipe,
    PlaceNamePipe,
    PlacePipe,
    TimeFormatPipe,
    DateTransformPipe,
    AirlineNamePipe,
    FlightDurationPipe,
    AirlineImagePipe,
    AutocompleteVmPipe,
    TotalAmountPipe,
    AirValidationSectorVmPipe,
    ArrivalDaysPipe,
    BusCompanyNamePipe,
    BusCompanyImagePipe,
    TerminalNamePipe,
    UniqueIdPipe,
    CountriesVmPipe,
    CountryCodePipe,
    FrequentFlyerProgramsPipe,
    CountryNamePipe,
    PriceAbbreviationPipe,
    StopNamePipe,
    CapitalizePipe,
    CapitalizeAllPipe,
    DeeplinkPlacePipe,
    ImageDesktopOrMobilePipe,
    PackageResumePipe,
    PackageResumeDesktopPipe,
    UserHistoryFormatPipe,
    AirlinePoliciesLinkPipe,
    GuestToPassengerUIPipe,
    DateRemoveDotsPipe,
    ListAirlineNamesPipe,
    ExchangeCurrencyPipe,
    ImageHttpsPipe,
    PackageReservationFlightFormatPipe,
    FrequentFlyerNamePipe,
    SafeHtmlPipe,
    ProvincesByPipe,
    TravelerDocumentsPipe,
    HistoryListByTabPipe,
    OrderByPipe,
    CountryCodeByAirportPipe
  ]
})
export class GlobalPipesModule { }
